import React from 'react';
import Helmet from 'react-helmet';
import Styled from 'styled-components';
import Grid from '../human-kit-react-web/components/layout/Grid';

const Wrapper = Styled.div`
  flex-grow: 1;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const SectionContent = Styled.div`
  max-width: 360px;
  margin-left: ${props => props.right ? '80px' : null};
  margin-right: ${props => props.left ? '80px' : null};

  h3 {
    color: #422B25;
    font-size: 28px;
    line-height: 32px;
    font-weight: 600;
    margin-bottom: 27px;
  }

  p {
    line-height: 24px;
  }
`;

const Section = Styled(Grid.Container)`
  margin-top: 108px;
  margin-bottom: 108px;
  justify-content: ${props => props.right ? 'flex-end' : 'flex-start'};
  align-items: center;
`;

const Diagram = Styled.div`
  flex: 1;
  min-height: 450px;
  background-image: ${props => `url(${props.image})`};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center right;
`;

const LongForm = Styled.div`
  max-width: 600px;

  a {
    color: black;
  }

  h1 {
    color: #422B25;
    font-size: 32px;
    line-height: 36px;
    font-weight: 600;
    margin-top: 27px;
  }

  h2 {
    color: #787878;
    font-size: 24px;
    line-height: 32px;
    font-weight: 300;
    margin-top: 9px;
    margin-bottom: 27px;
  }

  h3 {
    color: #422B25;
    font-size: 20px;
    line-height: 32px;
    font-weight: 600;
    margin-top: 27px;
    margin-bottom: 9px;
  }

  em {
    font-style: italic;
  }

  p {
    line-height: 24px;
  }
`;

const Author = Styled.div`
  display: flex;
  align-items: center;
  margin: 12px 0 24px;
  line-height: 20px;
`;

const BlogPage = () => (
  <Wrapper>
    <Helmet title="Frequently Asked Questions | CommCards" />
    <Grid.Container>
      <LongForm>
        <h1>Frequently Asked Questions</h1>
        <br />
        <h3>What is CommCards?</h3>
        <p>CommCards is an app that connects people with similar interests. We help make networking productive and easy, so get out there and do what you do best.</p>
        <h3>Can you customize which social media accounts and contact information is public?</h3>
        <p>Yes! You can easily add or remove which social media accounts, or contact channels you want to share when editing your profile card. You choose what information you want people to see.</p>
        <h3>Are my social links public?</h3>
        <p>No, only people who you’ve connected with or received your private share link can view your social links. Even then, they will only see the data that you share publicly on that platform.</p>
        <h3>What if I want to share my profile card with someone who doesn’t have CommCards?</h3>
        <p>No problem, we've got you covered! You can easily share your card by sending them a private link. If they don’t have the app, they will still be able to view your profile card and click to your social media profiles all within their browser.</p>
        <h3>How do you use my social media data?</h3>
        <p>Our system reads through text like the bios and descriptions of people you follow or pages you like to determine your interests. We then match you with other profiles interested in similar topics, in much the same way a human would if we gave them the task. The interests we predict for your profile will never be shared.</p><br />
        <p><em>If you don't want to connect your profiles, don't worry! You can always input your interests manually on your profile (or do both).</em></p>
        <h3>Is CommCards secure?</h3>
        <p>Absolutely! Everything is stored on encrypted servers. Passwords and authentication are managed by <a href="https://firebase.google.com/products/auth/#comprehensive-security">Google's Firebase Authentication Service</a>. Your data is yours. You can read our privacy policy to find out more.</p>
      </LongForm>
    </Grid.Container>
  </Wrapper>
)

export default BlogPage;



// WEBPACK FOOTER //
// ./src/pages/faq.js